// T050 — Boost completed event definition.

import type { EventDefinition } from './navigation';

export type BoostCompletedProperties = {
  marketPubkey: string;
  amountUsdc: number;
  signature: string;
};

export const BOOST_COMPLETED: EventDefinition<BoostCompletedProperties> = {
  name: 'boost_completed',
};
